import { computed } from 'vue'

import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useProductUrlToAlgoliaObjectId() {
  const { grade, productId } = useUrlParams()

  return computed(() => {
    if (!grade.value) return null

    return `${productId}_${grade.value}_0`
  })
}
